// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoVideo__container-d05dff {
  display: flex;
  align-items: center;
  flex-direction: column;
  align-self: center;
  flex: 1;
}

.NoVideo__title-d44ebb {
  margin-top: 24px;
  color: var(--addition-50);
  font: var(--font-title-6);
  max-width: 640px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/NoVideo/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  align-self: center;\n  flex: 1;\n}\n\n.title {\n  margin-top: 24px;\n  color: var(--addition-50);\n  font: var(--font-title-6);\n  max-width: 640px;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NoVideo__container-d05dff`,
	"title": `NoVideo__title-d44ebb`
};
module.exports = ___CSS_LOADER_EXPORT___;
